import React from "react";
export default class Step2 extends React.Component {
    render() {
        const { allergens, handleChange, selections } = this.props;
        return (React.createElement("div", { className: "card card-body allergy-card" },
            React.createElement("p", null, "If you have any allergies please let us know by selecting up to 3 from the options below."),
            React.createElement("div", { className: "row allergies-row" }, allergens.map((allergen, idx) => (React.createElement("div", { className: "allergy", key: idx },
                React.createElement("div", { className: "form-check custom-check" },
                    React.createElement("input", { className: "form-check-input", type: "checkbox", name: "allergens", disabled: selections.length > 2 && !selections.includes(`${allergen.id}`), value: allergen.id, id: `allergen-${allergen.id}`, onChange: (e) => handleChange(e, "allergens") }),
                    React.createElement("label", { className: "form-check-label", htmlFor: `allergen-${allergen.id}` },
                        React.createElement("span", { className: "custom-check-text" }, allergen.name)))))))));
    }
}
